export default __webpack_public_path__ + "static/stacked-bar-8b1e5e2b905c0e13afb7ff3d877ce6d2.png";